import React from 'react';
import { InfoIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
export function About() {
  return <section className="bg-cream px-4 pb-14 sm:px-5 sm:pb-24" data-id="element-20" data-mp="2psi8f4rnwtsc">
      <Reveal data-id="element-21" data-mp="2tt25y9g5dzf0">
        <div className="mx-auto flex max-w-3xl gap-4 rounded-[1.25rem] border-2 border-ink/10 bg-white p-5 sm:gap-5 sm:rounded-[1.5rem] sm:p-8" data-id="element-22" data-mp="2tskdlnwlw5cd">
          <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-sand" aria-hidden="true" data-id="element-23" data-mp="2ytgf5uthjfem">
            <InfoIcon className="h-5 w-5 text-ink" aria-hidden="true" data-id="element-24" data-mp="33pf9dz1hvrmy" />
          </span>
          <div data-id="element-25" data-mp="38o8ccxj5o08v">
            <h2 className="text-base font-black leading-snug text-ink sm:text-lg" data-id="element-26" data-mp="38o01tcai970u">
              Cos’è il Laboratorio del Giovane Inventore
            </h2>
            <p className="mt-2 text-[15px] font-semibold leading-relaxed text-ink/65 sm:mt-2.5 sm:text-base" data-id="element-27" data-mp="3hhd24zawfawy">
              È un sistema digitale in PDF con 6 volumi e 5 bonus di progetti
              guidati per bambini dai 5 ai 12 anni, pensato per famiglie senza
              alcuna esperienza tecnica. Non è un abbonamento, non è un’app e
              non è un kit fisico: ricevi i file, scegliete una missione e la
              costruite con i materiali che avete già in casa.
            </p>
          </div>
        </div>
      </Reveal>
    </section>;
}